import { Injectable } from '@angular/core';
import { NavigationService } from '../../../core/navigation.service';
import { ConfirmDialogService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { AlertService } from 'sce-core';
import { SearchableEntityButtonService } from './searchable-entity-button.service';
import { SearchableEntityBackendService } from './searchable-entity-backend.service';
import { SearchableEntityDataService } from './searchable-entity-data.service';
import { SearchableEntityDataEditorService } from './searchable-entity-data-editor.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchService } from '../../search/search.service';
import { ValidatorService } from '../validator.service';
import { SearchEvent } from '../../search/models/search-event';
import { REFRESH_SEARCH_EVENT } from '../../search/search-constants';
import { ModalService } from '../modal.service';
import * as XLSX from 'xlsx';

@Injectable()
export class SearchableEntityActionService {

  public errorMsg: string = '';
  public successMsg: string = '';
  public dialogMsg: string = '';
  public columnDef: any[];

  protected dataService: SearchableEntityDataService;
  protected buttonService: SearchableEntityButtonService;
  protected backendService: SearchableEntityBackendService;
  protected dataEditor: SearchableEntityDataEditorService;

  protected navService: NavigationService;
  protected confirmDialogService: ConfirmDialogService;
  public alertService: AlertService;
  protected resourceService: ResourceService;
  protected modalService: ModalService;
  protected validatorService: ValidatorService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
      protected sharedServiceRegistry: SharedServiceRegistry) {
    this.navService = coreServiceRegistry.navigationService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.alertService = sharedServiceRegistry.alertService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
    this.modalService = sharedServiceRegistry.sceModalService;
    this.validatorService = sharedServiceRegistry.validatorService;
  }

  public setDependentServices(dataService, buttonService, dataEditor, backendService) {
    this.dataService = dataService;
    this.buttonService = buttonService;
    this.dataEditor = dataEditor;
    this.backendService = backendService;
  }

  // common function for export
  public exportData(searchService: SearchService, format: string,tableId?: string) {
    if (!searchService || !format) {
      this.alertService.error('');
    }
    // Filter searchCriteria with * in fac/storer. Assuming condition[0] is the first mandatory condition
    let clausesWithStarFacilityStorer;
    // LFWM-2624 - added change to check if conditions is not empty
    if (searchService.searchCriteria.conditions.length > 0 ) {
     clausesWithStarFacilityStorer = searchService.searchCriteria.conditions[0].clauses
        .filter(clause => (clause.column === 'storerKey' ||  clause.column === 'facility') && clause.value === '*');
    }
        // check if any storer clause or facility clause with * is present in filtered data.
        // LFWM-2624 - change to check if clausesWithStarFacilityStorer is not undefined
    if (clausesWithStarFacilityStorer && clausesWithStarFacilityStorer.length > 0) {
      //     LFWM-1880  --  Export function restriction
      this.alertService.error(this.resourceService.get('msg_export_star_facstorer'));
      return;
    }
    // Alert user and continue export in background
    this.alertService.warn(this.resourceService.get('msg_export_bg_info'));
    if (tableId === 'STKTAKIMPTD') {
      searchService.exportDataWithoutPrivilege(format, tableId).subscribe((resp) => {
        const blob = new Blob([this.s2ab(atob(resp.content))]);
        const file = new File([blob], resp.fileName,
          { type: 'text/csv' });
        this.sharedServiceRegistry.fileUtilityService.saveFileLocally(file);
      }, (error) => {
        // LFWM-2801 - change to display error msg when export fails
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
    }
    else{
    searchService.exportData(format, tableId).subscribe((resp) => {
      const   blob   =   new   Blob([this.s2ab(atob(resp.content))]);
      const   file   =   new   File([blob], resp.fileName,
        {  type:   'text/csv'  });
      this.sharedServiceRegistry.fileUtilityService.saveFileLocally(file);
    }, (error) => {
      // LFWM-2801 - change to display error msg when export fails
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }
  }

  public s2ab(s) {
    const  buf  =  new  ArrayBuffer(s.length);
    const  view  =  new  Uint8Array(buf);
    for  (let  i = 0;  i !== s.length;  ++i) {
      // tslint:disable-next-line:no-bitwise
      view[i]  =  s.charCodeAt(i)  &  0xFF;
    }
    return  buf;
  }

  // Method used to copy value to all rows for locally paged screens
  public copyValueToAllRowsForLocallyPaged() {
    const noOfLineItems = this.dataService.searchService.fullData.length;
    let selectedColumnToCopy = '';
    let valueToCopy = '';
    if (this.dataService.searchService.getFocusedRow().cName) {
      selectedColumnToCopy = this.dataService.searchService.getFocusedRow().cName;
    }
    if (this.dataService.searchService.getFocusedRow().row) {
      valueToCopy = this.dataService.searchService.getFocusedRow().row.cells[selectedColumnToCopy].cVal;
    }
    if (noOfLineItems === 0) {
      this.alertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return;
    }
    // code to copy the focused row value to all rows
    // LFWM-2657 setting isEdited flag value as true after copying value.
      const allLineItems = this.dataService.searchService.fullData;
      allLineItems.forEach((lineItemRows: any) => {
      const lineItemCells = lineItemRows.cells;
      lineItemCells[selectedColumnToCopy].cVal = valueToCopy;
      lineItemRows.isEdited = true;
      });
      this.dataService.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
  }
  // [LFWM-2681] made downloadTemplate functionality as generic.
  public downloadTemplate(format: any, fileName: any, columListForTemplate: any ,sheetName?: any) {
    // file content is differed with respect to format
    let file: any;
    if (format === 'excel') {
      // creating a work book
      const workBook = XLSX.utils.book_new();
      // creating and adding a new sheet to work book
      workBook.SheetNames.push(sheetName);
       // array of array - a row with n no. of columns [no of column based on screen]
      const workSheetData = [columListForTemplate];
      //  create the sheet from this array by using aoa_to_sheet()
      const workSheet = XLSX.utils.aoa_to_sheet(workSheetData);
      // assigning the sheet object to the workbook Sheets array.
      workBook.Sheets[sheetName] = workSheet;
      /* Need to export the workbook as xlsx binary. Use write function
      then pass the bookType as xlsx and output Type as binary */
      const wbout = XLSX.write(workBook, { bookType: 'xlsx', type: 'binary' });
      /* The correct content type for excel file is octet stream
      so you will need to convert the binary data into octet.
      We can achieve that by using arrayBuffer, UInt8Array and bit operation */
      const blob = new Blob([this.s2ab(wbout)]);
      file = new File([blob], fileName,
        { type: 'application/octet-stream' });
    } else if (format === 'csv') {
      let fileContent = '';  // file content should be a string separated with comma and space
      columListForTemplate.forEach(columnName => {
        fileContent = fileContent + columnName + ', ';
      });
      fileContent = fileContent.trim();
      file = new File([fileContent], fileName,
        { type: 'text/csv' });
    } else { // text format
      let fileContent = ''; // file content should be a string separated with space
      columListForTemplate.forEach(columnName => {
        fileContent = fileContent + columnName + ' ';
      });
      file = new File([fileContent], fileName,
        { type: 'text/csv' });
    }

    this.sharedServiceRegistry.fileUtilityService.saveFileLocally(file);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/searchable-entity-action.service.ts